import React from 'react';
import { GridWrapper } from './styled';
import { GRID_LAYOUT_TESTID, GRID_WRAPPER_CONTENT_CLASS, GRID_WRAPPER_FOOTER_CLASS, GRID_WRAPPER_HEADER_CLASS } from './constants';
var GridLayout = function GridLayout(_ref) {
  var _ref$dataTest = _ref.dataTest,
    dataTest = _ref$dataTest === void 0 ? GRID_LAYOUT_TESTID : _ref$dataTest,
    header = _ref.header,
    footer = _ref.footer,
    children = _ref.children,
    showOnlyPm = _ref.showOnlyPm,
    reviewStepEnabled = _ref.reviewStepEnabled,
    hasNeedHelpButton = _ref.hasNeedHelpButton;
  var footerClassName = !showOnlyPm ? GRID_WRAPPER_FOOTER_CLASS : '';
  var disableStickyFooter = reviewStepEnabled ? true : false;
  return /*#__PURE__*/React.createElement(GridWrapper, {
    "data-test": dataTest,
    disableStickyFooter: disableStickyFooter,
    hasNeedHelpButton: !!hasNeedHelpButton
  }, header && /*#__PURE__*/React.createElement("div", {
    className: GRID_WRAPPER_HEADER_CLASS
  }, header), /*#__PURE__*/React.createElement("div", {
    className: GRID_WRAPPER_CONTENT_CLASS,
    id: GRID_WRAPPER_CONTENT_CLASS
  }, children), footer && /*#__PURE__*/React.createElement("div", {
    className: footerClassName
  }, footer));
};
export default GridLayout;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/components/modules/GridLayout/index.js
// module id = 1460
// module chunks = 11